var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 1.6C0.399902 2.02435 0.568474 2.43131 0.868532 2.73137C1.16859 3.03143 1.57556 3.2 1.9999 3.2C2.42425 3.2 2.83121 3.03143 3.13127 2.73137C3.43133 2.43131 3.5999 2.02435 3.5999 1.6C3.5999 1.17565 3.43133 0.768687 3.13127 0.468629C2.83121 0.168571 2.42425 0 1.9999 0C1.57556 0 1.16859 0.168571 0.868532 0.468629C0.568474 0.768687 0.399902 1.17565 0.399902 1.6Z",
    fill: "#576473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 8.00002C0.399902 8.42437 0.568474 8.83134 0.868532 9.1314C1.16859 9.43145 1.57556 9.60002 1.9999 9.60002C2.42425 9.60002 2.83121 9.43145 3.13127 9.1314C3.43133 8.83134 3.5999 8.42437 3.5999 8.00002C3.5999 7.57568 3.43133 7.16871 3.13127 6.86865C2.83121 6.5686 2.42425 6.40002 1.9999 6.40002C1.57556 6.40002 1.16859 6.5686 0.868532 6.86865C0.568474 7.16871 0.399902 7.57568 0.399902 8.00002Z",
    fill: "#576473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 14.4C0.399902 14.8243 0.568474 15.2313 0.868532 15.5314C1.16859 15.8314 1.57556 16 1.9999 16C2.42425 16 2.83121 15.8314 3.13127 15.5314C3.43133 15.2313 3.5999 14.8243 3.5999 14.4C3.5999 13.9756 3.43133 13.5687 3.13127 13.2686C2.83121 12.9686 2.42425 12.8 1.9999 12.8C1.57556 12.8 1.16859 12.9686 0.868532 13.2686C0.568474 13.5687 0.399902 13.9756 0.399902 14.4Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.e86e98c858a7b4310e656eabd1c74707.svg";
export { ForwardRef as ReactComponent };